import { extend, override } from 'flarum/common/extend';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import ModalManagerState from 'flarum/common/states/ModalManagerState';
import SearchManager from 'flarum/common/SearchManager';
import GlobalTagsSearchSource from './components/GlobalTagsSearchSource';

// `flarum.reg` is the runtime module registry every compiled Flarum bundle
// reads/writes through; there's no TS-visible import for it since it's a
// build-time external, not a real module.

let searchModalPatched = false;

/**
 * SearchModal is lazy-loaded by core (see `AbstractGlobalSearch`'s
 * `openSearchModal`), so it isn't registered in `flarum.reg` — and can't be
 * imported — until the search modal has been opened at least once this
 * session. This is called once at boot (a no-op, since nobody's opened the
 * modal yet) and again after every modal show, until it can actually find
 * and patch the class.
 */
function patchSearchModal() {
  if (searchModalPatched) return;
  const SearchModalClass = flarum.reg.get('core', 'common/components/SearchModal');
  if (!SearchModalClass) return;
  searchModalPatched = true;

  // Tags are a small, cheap-to-query list (unlike discussions/posts
  // full-text search), so there's no need to wait for
  // `SearchManager.minSearchLength()` (3 characters) before suggesting them.
  override(SearchModalClass.prototype, 'search', function (original, query) {
    const source = this.activeSource();
    if (!query || source?.resource !== 'tags') {
      original(query);
      return;
    }
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = window.setTimeout(() => {
      if (source.isCached(query)) return;
      this.loadingSources.push(source.resource);
      source.search(query, SearchModalClass.LIMIT).then(() => {
        this.loadingSources = this.loadingSources.filter(resource => resource !== source.resource);
        m.redraw();
      });
      this.searchState.cache(query);
      m.redraw();
    }, SearchManager.SEARCH_DEBOUNCE_TIME_MS);
  });
}
app.initializers.add('hli-tag-search', () => {
  extend(GlobalSearch.prototype, 'sourceItems', function (items) {
    if (app.forum.attribute('canViewForum')) {
      // Below the core sources' default priority (0), so it doesn't become
      // the search modal's default tab.
      items.add('tags', new GlobalTagsSearchSource(), -10);
    }
  });
  patchSearchModal();
  extend(ModalManagerState.prototype, 'show', function (returnValue) {
    returnValue.then(patchSearchModal);
  });
});